<template>
  <div class="company-edit-container">
      <RailbankEdit v-if="venderType ==='railsbank' && companyForm" :formData="companyForm" />
      <ModulrEdit v-if="venderType ==='modulr' && companyForm" :formData="companyForm"/>
  </div>
</template>

<script>
import RailbankEdit from './components/vender-railbank-edit-form'
import ModulrEdit from './components/vender-modulr-edit-form'
import {
  getCompanyBy,
} from "@/api/company";
export default {
    components: {
        RailbankEdit,
        ModulrEdit
    },
    data(){
        return {
            venderType: "railbank",
            companyForm: null
        }
    },
    methods:{
        sortData(data){
            var result1 = [], result2 = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].position === 'DIRECTOR') {
                    result1.push(data[i]);
                } else {
                    result2.push(data[i]);
                }
            }

            result2.sort((a, b) => a.position - b.position)
            
            return result1.concat(result2)
        },
        getDataToEdit(uid) {
            const loading = this.$notifyloading("Loading data...");
            getCompanyBy(uid).then(({ result, data }) => {
                loading.close();
                if (result) {
                    this.companyForm = data
                    this.venderType = data.kyc.venderType || "railsbank";

                    if(this.venderType === 'modulr'){
                        this.companyForm['company'] = data.kyc.company
                        this.companyForm['venderType'] = data.kyc.venderType
                        this.companyForm['associates'] = this.sortData(data.kyc.associates)

                        delete this.companyForm['kyc']
                    }
                }
            });
        },
    },
    mounted(){
        this.getDataToEdit(this.$route.params.uid);
    },
    
}
</script>

<style>

</style>